// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3SSp6","fullView":"styles_fullView__35S3K"};